/**
 * PostHog Redux Action Creators
 */

import {
  PosthogActionTypes,
  PosthogConfig,
  PosthogUser,
  PosthogEventProperties,
  InitPosthogAction,
  TrackEventAction,
  IdentifyUserAction,
  ResetUserAction,
  SetUserPropertiesAction,
  PageViewAction,
} from './types';

export const initPosthog = (config: PosthogConfig): InitPosthogAction => ({
  type: PosthogActionTypes.INIT_POSTHOG,
  payload: config,
});

export const trackEvent = (
  event: string,
  properties?: PosthogEventProperties
): TrackEventAction => ({
  type: PosthogActionTypes.TRACK_EVENT,
  payload: {
    event,
    properties,
  },
});

export const identifyUser = (user: PosthogUser): IdentifyUserAction => ({
  type: PosthogActionTypes.IDENTIFY_USER,
  payload: user,
});

export const resetUser = (): ResetUserAction => ({
  type: PosthogActionTypes.RESET_USER,
});

export const setUserProperties = (
  properties: Record<string, any>
): SetUserPropertiesAction => ({
  type: PosthogActionTypes.SET_USER_PROPERTIES,
  payload: properties,
});

export const trackPageView = (
  path: string,
  properties?: PosthogEventProperties
): PageViewAction => ({
  type: PosthogActionTypes.PAGE_VIEW,
  payload: {
    path,
    properties,
  },
});